<template>
  <div class="candidate-root">
    <header class="page-brand" aria-hidden="true">
      <img class="brandLogo" :src="brandLogoSrc" alt="ePRO易宝" />
    </header>

    <div class="shell">
      <section class="visual" aria-hidden="true">
        <img class="visual-img" :src="illustrationSrc" alt="" />
      </section>

      <section class="panel">
        <div class="panel-card">
          <header class="brand">
            <div class="brandTitle">AI视频面试平台</div>
          </header>


          <section class="card" aria-label="面试邀请信息">
            <div class="cardTitle">面试邀请信息</div>
            <div class="rows">
              <div>面试岗位：<strong>{{ inviteInfo.position || "-" }}</strong></div>
              <div>面试时间：<strong>{{ inviteInfo.interview_time || "-" }}</strong></div>
              <div>面试官：<strong>{{ inviteInfo.interviewer || "-" }}</strong></div>
            </div>
          </section>

          <section  aria-label="登录表单">
            <form class="loginForm" novalidate @submit.prevent="onSubmit">
              <label>
                <div class="field-with-icon field-with-icon--muted" :class="{ 'field-with-icon--disabled': formLocked }">
                  <img class="field-icon" :src="iconPhone" alt="" />
                  <input
                    v-model.trim="form.phone"
                    type="tel"
                    inputmode="numeric"
                    maxlength="11"
                    placeholder="请输入您的手机号"
                    :disabled="formLocked"
                  />
                </div>
              </label>

              <label>
                <div class="field-with-icon field-with-icon--muted" :class="{ 'field-with-icon--disabled': formLocked }">
                  <img class="field-icon" :src="iconAccount" alt="" />
                  <input
                    v-model.trim="form.name"
                    type="text"
                    maxlength="20"
                    placeholder="请输入您的姓名"
                    :disabled="formLocked"
                  />
                </div>
              </label>

              <label>
                <div class="field-inline">
                  <div class="field-with-icon field-with-icon--flex">
                    <img class="field-icon" :src="iconCaptcha" alt="" />
                    <input
                      v-model.trim="form.code"
                      type="text"
                      inputmode="numeric"
                      maxlength="6"
                      placeholder="请输入验证码"
                    />
                  </div>
                  <el-button
                    size="small"
                    native-type="button"
                    class="secondary"
                    :disabled="codeLeft > 0 || sendingCode"
                    @click="sendCode"
                  >
                    {{ sendingCode ? "发送中..." : (codeLeft > 0 ? codeLeft + "秒后重试" : "获取验证码") }}
                  </el-button>
                </div>
              </label>

              <div class="agree">
                <input id="agree" v-model="form.agree" type="checkbox" />
                <span>
                  我已阅读并同意
                  <a href="javascript:void 0" @click.prevent="openPrivacyDialog">《隐私协议》</a>
                  和
                  <a href="javascript:void 0" @click.prevent="openGuideDialog">《面试须知》</a>
                </span>
              </div>

              <el-button size="small" native-type="submit" class="primary" :disabled="!canSubmit">
                登录并进入面试准备
              </el-button>
            </form>
  
          </section>
        </div>
      </section>
    </div>

    <!-- 隐私协议弹窗 -->
    <el-dialog
      title="隐私协议"
      :visible.sync="privacyDialogVisible"
      width="650px"
      custom-class="doc-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @closed="privacyIframeKey = Date.now()"
    >
      <iframe
        :key="privacyIframeKey"
        v-show="privacyDialogVisible"
        src="/隐私协议.html"
        class="doc-iframe"
        frameborder="0"
      />
    </el-dialog>

    <!-- 面试须知弹窗 -->
    <el-dialog
      title="面试须知"
      :visible.sync="guideDialogVisible"
      width="650px"
      custom-class="doc-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @closed="guideIframeKey = Date.now()"
    >
      <iframe
        :key="guideIframeKey"
        v-show="guideDialogVisible"
        src="/面试须知.html"
        class="doc-iframe"
        frameborder="0"
      />
    </el-dialog>
  </div>
</template>

<script>
import illustrationSrc from "@/assets/home-illustration.png";
import brandLogoSrc from "@/assets/brand-logo.png";
import iconPhone from "@/assets/手机号.png";
import iconAccount from "@/assets/icon-account.svg";
import iconCaptcha from "@/assets/icon-captcha.svg";
import { Message } from "element-ui";
import { getInterviewDetail, sendLoginSmsCode, smsLogin } from "@/api/candidateAuth";
import { setToken } from "@/utils/token";

export default {
  name: "CandidateLogin",
  data() {
    return {
      illustrationSrc,
      brandLogoSrc,
      iconPhone,
      iconAccount,
      iconCaptcha,
      form: { phone: "", name: "", code: "", agree: false },
      inviteInfo: {
        position: "",
        interview_id: "",
        interview_time: "",
        interviewer: "",
        recruiters: "",
        recruiters_phone: "",
        candidate_phone: "",
        candidate_name: "",
      },
      errorMsg: "",
      codeLeft: 0,
      sendingCode: false,
      timer: null,
      formLocked: false,
      privacyDialogVisible: false,
      guideDialogVisible: false,
      privacyIframeKey: 0,
      guideIframeKey: 0,
    };
  },
  computed: {
    canSubmit() {
      return (
        /^1\d{10}$/.test(this.form.phone) &&
        !!this.form.name &&
        /^\d{6}$/.test(this.form.code) &&
        this.form.agree
      );
    },
  },
  beforeDestroy() {
    if (this.timer) window.clearInterval(this.timer);
    window.removeEventListener("message", this.handleDocDialogMessage);
  },
  mounted() {
    this.fetchInterviewInvite();
    window.addEventListener("message", this.handleDocDialogMessage);
  },
  methods: {
    handleDocDialogMessage(event) {
      const data = event && event.data;
      if (!data || data.type !== "close-doc-dialog") return;
      if (data.doc === "privacy") {
        this.privacyDialogVisible = false;
      } else if (data.doc === "guide") {
        this.guideDialogVisible = false;
      }
    },
    getInterviewToken() {
      return String((this.$route && this.$route.query && this.$route.query.token) || "").trim();
    },
    getStoredInterviewId() {
      try {
        return String(sessionStorage.getItem("candidate_interview_id") || "").trim();
      } catch (_) {
        return "";
      }
    },
    async fetchInterviewInvite() {
      const token = this.getInterviewToken();
      if (!token) return;
      try {
        const res = await getInterviewDetail(token);
        // 接口返回根对象（没有 data 层）；兼容旧结构
        const data = (res && res.data) ? res.data : (res || {});
        this.inviteInfo = {
          position: data.position || "",
          interview_id: data.interview_id || "",
          interview_time: data.interview_time || "",
          interviewer: data.interviewer || "",
          recruiters: data.recruiters || "",
          recruiters_phone: data.recruiters_phone || "",
          candidate_phone: data.candidate_phone || "",
          candidate_name: data.candidate_name || "",
        };

        // 给后续页面（CandidateEntry 第三步等待室）取用
        try {
          sessionStorage.setItem("candidate_invite_info", JSON.stringify(this.inviteInfo));
          sessionStorage.setItem("candidate_interview_id", String(this.inviteInfo.interview_id || ""));
        } catch (e) {
          // ignore
        }

        // 从面试邀请信息填充手机号/姓名，并锁定输入（置灰）
        this.form.phone = this.inviteInfo.candidate_phone || "";
        this.form.name = this.inviteInfo.candidate_name || "";
        this.formLocked = true;
      } catch (e) {
        console.error("[CandidateLogin] 获取面试邀请信息失败", e);
        try {
          sessionStorage.removeItem("candidate_invite_info");
          sessionStorage.removeItem("candidate_interview_id");
        } catch (_) {
          // ignore
        }
      }
    },
    async sendCode() {
      if (this.sendingCode || this.codeLeft > 0) return;
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.errorMsg = "";
        Message({
          type: "warning",
          message: "请先输入您的手机号",
        });
        return;
      }
      this.errorMsg = "";
      this.sendingCode = true;
      try {
        const res = await sendLoginSmsCode({ phone_number: this.form.phone });
        const isSuccess = !!(res && res.success === true);
        if (!isSuccess) {
          this.errorMsg = (res && res.message) || "验证码发送失败，请稍后重试。";
          return;
        }

        this.codeLeft = 60;
        if (this.timer) window.clearInterval(this.timer);
        this.timer = window.setInterval(() => {
          this.codeLeft -= 1;
          if (this.codeLeft <= 0) {
            window.clearInterval(this.timer);
            this.timer = null;
            this.codeLeft = 0;
          }
        }, 1000);
        Message.success("验证码已发送");
      } catch (e) {
        const detail = e && e.data && Array.isArray(e.data.detail) ? e.data.detail : [];
        const firstMsg = detail.length && detail[0] && detail[0].msg ? detail[0].msg : "";
        this.errorMsg = firstMsg || "验证码发送失败，请稍后重试。";
      } finally {
        this.sendingCode = false;
      }
    },
    async onSubmit() {
      this.errorMsg = "";
      const phoneOk = /^1\d{10}$/.test(this.form.phone);
      const nameOk = !!this.form.name.trim();
      const codeOk = /^\d{6}$/.test(this.form.code);
      const agreeOk = !!this.form.agree;

      if (!phoneOk) {
        this.errorMsg = "请先输入正确的 11 位手机号。";
        return;
      }
      if (!nameOk) {
        this.errorMsg = "请输入姓名。";
        return;
      }
      if (!codeOk) {
        this.errorMsg = "验证码为 6 位数字。";
        return;
      }
      if (!agreeOk) {
        this.errorMsg = "请先勾选同意相关协议。";
        return;
      }

      try {
        const res = await smsLogin({
          phone_number: this.form.phone,
          sms_code: this.form.code,
        });
        const payload = res || {};
        const accessToken = payload.access_token || payload.accessToken || payload.token || "";
        const tokenType = payload.token_type || payload.tokenType || "Bearer";
        if (!accessToken) {
          const msg = payload.message || "登录失败，请检查验证码后重试。";
          this.errorMsg = msg;
          return;
        }

        // 保存 token：给后续接口请求拦截器使用（Authorization），sessionStorage 按页签隔离
        setToken({ accessToken, tokenType });

        try {
          const userInfoRaw = payload.user_info || payload.userInfo || res;
          if (userInfoRaw) {
            sessionStorage.setItem(
              "user_info",
              typeof userInfoRaw === "string" ? userInfoRaw : JSON.stringify(userInfoRaw)
            );
          }
        } catch (e) {
          // ignore
        }

        // 可选：写入 vuex，保持和 Home.vue 行为一致
        if (this.$store && typeof this.$store.commit === "function") {
          const userInfo = payload.user_info || payload.userInfo || null;
          this.$store.commit("setAuth", { accessToken, tokenType, userInfo });
        }
        // Message.success("登录成功");

        this.$router.push({
          path: "/candidate/entry",
          query: {
            name: this.form.name,
            phone: this.form.phone,
            token: this.getInterviewToken(),
            interview_id: this.getStoredInterviewId(),
          },
        });
      } catch (e) {
        const detail = e && e.data && Array.isArray(e.data.detail) ? e.data.detail : [];
        const firstMsg = detail.length && detail[0] && detail[0].msg ? detail[0].msg : "";
        const msg = firstMsg || "登录失败，请稍后重试。";
        this.errorMsg = msg;
      }
    },
    openPrivacyDialog() {
      this.privacyDialogVisible = true;
    },
    openGuideDialog() {
      this.guideDialogVisible = true;
    },
    handleHelpClick() {
      this.$alert(
        "技术支持（原型）：\n\n请检查浏览器权限、网络连接，并尝试更换浏览器。\n如仍有问题，可联系 HR 或技术支持。",
        "提示",
        { confirmButtonText: "我知道了" }
      );
    },
  },
};
</script>

<style scoped>
.candidate-root {
  --bg: #f1f4ff;
  --panel-bg: #ffffff;
  --text: #0f172a;
  --muted: #64748b;
  --line: rgba(15, 23, 42, 0.06);
  --brand: #3b6cff;
  --radius: 18px;
  --radius-sm: 8px;
  --focus: 0 0 0 4px rgba(59, 108, 255, 0.16);

  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px 14px;
  background: var(--bg);
  color: var(--text);
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  box-sizing: border-box;
}

.page-brand {
  position: fixed;
  top: 20px;
  left: 32px;
  z-index: 10;
}

.brandLogo {
  height: 32px;
  width: auto;
  display: block;
}

.shell {
  width: 100%;
  max-width: 1050px;
  min-height: 520px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1.35fr 1fr;
}

.visual {
  position: relative;
  padding: 28px 28px;
  background: var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.visual-img {
  position: relative;
  width: min(520px, 92%);
  height: auto;
  max-height: 440px;
  object-fit: contain;
}

.panel {
  padding: 28px 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-card {
  width: 100%;
  max-width: 480px;
  border-radius: var(--radius);
  background: var(--panel-bg);
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: none;
  padding: 28px 26px 24px;
  display: flex;
  flex-direction: column;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.logo {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.logoImg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.brandTitle {
  font-weight: 900;
  letter-spacing: 0.5px;
  font-size: 18px;
  width: 100%;
  text-align: center;
  font-size: 22px;
}

h1 {
  margin: 0 0 4px;
  font-size: 22px;
  font-weight: 900;
}

.subtitle {
  margin: 0 0 18px;
  font-size: 13px;
  color: var(--muted);
}

.card {
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #ffffff;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.cardTitle {
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 6px;
}

.rows {
  font-size: 12px;
  color: var(--muted);
  line-height: 1.6;
}

.rows strong {
  color: #1a1a2e;
  font-weight: 800;
  color: #2563eb;
}

.loginForm {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.field-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #ffffff;
  padding: 0 10px;
  box-sizing: border-box;
}

.field-with-icon--muted {
  background: #ffffff;
}

.field-with-icon--disabled {
  background: #f1f5f9;
}

.field-with-icon--flex {
  flex: 1;
}

.field-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

label {
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.labTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.labTop span:first-child {
  font-weight: 800;
  color: #0f172a;
}

.labHint {
  font-size: 11px;
  color: var(--muted);
}

input[type="text"],
input[type="tel"] {
  border-radius: var(--radius-sm);
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #ffffff;
  color: var(--text);
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  transition: 0.12s ease;
}

input::placeholder {
  color: rgba(100, 116, 139, 0.65);
}

input:focus {
  border-color: var(--brand);
  box-shadow: var(--focus);
}

input:disabled {
  opacity: 0.65;
  background: transparent;
  cursor: not-allowed;
}

.field-with-icon input[type="text"],
.field-with-icon input[type="tel"] {
  border: none;
  box-shadow: none;
  padding: 10px 0;
  flex: 1;
  min-width: 0;
  background: transparent;
}

.field-inline {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.field-inline input {
  flex: 1;
}

button {
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  padding: 9px 12px;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  background: #ffffff;
  color: var(--text);
  transition: 0.12s ease;
}

button:hover {
  background: #f8fafc;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.secondary {
  background: #f1f5f9;
  font-weight: 600;
}

.primary {
  background: linear-gradient(135deg, #3b6cff, #4f86ff);
  border-color: var(--brand);
  color: #fff;
  box-shadow: none;
  width: 100%;
  margin-top: 4px;
}

.primary:hover {
  background: linear-gradient(135deg, #4f86ff, #3b6cff);
}

.agree {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 2px;
  font-size: 12px;
  color: var(--muted);
}

.agree input {
  margin-top: 2px;
}

.agree a {
  color: #2563eb;
  cursor: pointer;
  text-decoration: none;
}

.agree a:hover {
  text-decoration: underline;
}

.links {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: var(--muted);
}

.links a {
  color: inherit;
  text-decoration: none;
}

.links a:hover {
  text-decoration: underline;
}

.error {
  font-size: 12px;
  color: #ef4444;
  min-height: 16px;
  margin-top: 4px;
}

/* 协议/须知弹窗（el-dialog 挂载到 body，需用深度选择器） */
::v-deep .doc-dialog {
  max-width: calc(100vw - 24px);
}
::v-deep .doc-dialog .el-dialog__body {
  padding: 0;
}
::v-deep .doc-dialog .doc-iframe {
  width: 100%;
  height: 70vh;
  min-height: 400px;
  border: none;
  border-radius: 8px;
  display: block;
}

@media (max-width: 920px) {
  .shell {
    grid-template-columns: 1fr;
    max-width: 560px;
  }

  .visual {
    min-height: 280px;
    padding: 22px 20px;
  }

  .panel {
    padding: 22px 20px;
  }
}

@media (max-width: 768px) {
  .candidate-root {
    padding: 12px 10px 14px;
  }

  .brandTitle {
    font-size: 16px;
  }

  h1 {
    font-size: 18px;
  }

  .subtitle {
    font-size: 12px;
    margin-bottom: 14px;
  }

  .card {
    padding: 10px;
    margin-bottom: 8px;
    border-radius: 10px;
  }

  .cardTitle,
  .rows {
    font-size: 14px;
  }

  .loginForm {
    gap: 8px;
  }

  label {
    font-size: 12px;
  }

  .labTop {
    flex-wrap: wrap;
  }

  .labHint {
    width: 100%;
    font-size: 11px;
  }

  input[type="text"],
  input[type="tel"] {
    padding: 10px 10px;
    font-size: 16px;
    min-height: 40px;
    box-sizing: border-box;
  }

  .field-with-icon {
    padding: 0 10px;
  }

  .field-inline {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: stretch;
    gap: 8px;
  }

  .field-inline input {
    min-height: 44px;
  }

  .field-inline .field-with-icon--flex {
    min-width: 0;
  }

  .field-inline .secondary {
    min-height: 40px;
    width: auto;
    max-width: 42vw;
    white-space: nowrap;
    padding-left: 8px;
    padding-right: 8px;
  }

  .primary {
    min-height: 42px;
    padding: 10px;
    font-size: 15px;
  }

  .agree {
    font-size: 13px;
    gap: 6px;
  }

  .agree span {
    line-height: 1.5;
  }

  .links {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    font-size: 11px;
  }
}

@media (max-width: 560px) {
  .candidate-root {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 10px 12px;
  }

  /* 小屏避免 fixed logo 挡住表单 */
  .page-brand {
    position: static;
    margin: 4px 0 8px;
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  .brandLogo {
    height: 22px;
  }

  .shell {
    max-width: 420px;
    min-height: 0;
    border-radius: 16px;
    overflow: hidden;
    background: transparent;
  }

  .visual {
    min-height: 140px;
    padding: 10px 10px 6px;
  }

  .visual-img {
    width: min(300px, 78%);
    max-height: 140px;
  }

  .panel {
    padding: 0;
  }

  .panel-card {
    max-width: 100%;
    padding: 12px 12px 10px;
    border-radius: 16px;
    border-left: none;
    border-right: none;
  }

  .brandTitle {
    font-size: 16px;
  }

  .field-with-icon {
    padding: 0 10px;
  }

  .field-icon {
    width: 18px;
    height: 18px;
  }

  .field-with-icon input[type="text"],
  .field-with-icon input[type="tel"] {
    padding: 8px 0;
    font-size: 16px;
    min-height: 40px;
    box-sizing: border-box;
  }

  .field-inline {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: stretch;
    gap: 8px;
  }

  .field-inline .field-with-icon--flex {
    min-width: 0;
  }

  .field-inline .secondary {
    width: auto;
    max-width: 44vw;
    min-height: 40px;
    white-space: nowrap;
    padding-left: 6px;
    padding-right: 6px;
  }

  .primary {
    width: 100%;
  }
}
</style>

